import MultiSelectModal from './MultiSelectModal';

export default MultiSelectModal;
